import { SUPPORT_ITEM_TYPE } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import SupportItemTypePage from "./container/SupportItemTypePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SUPPORT_ITEM_TYPE,
    withSidebar: true,
    withAppBar: true,
    component: SupportItemTypePage,
  };
}
